/** ヘルプのパーマリンク。1 か所で決める（画面ごとに組み立てない）。 */
export function helpPath(slug?: string): string {
  return slug === undefined || slug === "" ? "/help" : `/help/${slug}`;
}
